/** @type {import('tailwindcss').Config} */

const tailwindCssForms = require('@tailwindcss/forms');

const colors = {
  'error-red': '#dc2626',
  'success-green': '#16a34a',
  'bacon': {
    50: '#fdf3f3',
    100: '#fbe6e5',
    200: '#f9d1cf',
    300: '#f3b1ae',
    400: '#ea847f',
    500: '#dd5c56',
    600: '#b73906',
    DEFAULT: '#b73906', // different from accounts
    700: '#a8322d',
    800: '#8c2c28',
    900: '#752a27',
    950: '#3f1210',
  },
  'beet': {
    50: '#fcf6f0',
    100: '#f8ebdc',
    200: '#f0d3b8',
    300: '#e7b68a',
    400: '#dc8f5b',
    500: '#d4733b',
    600: '#c65c30',
    700: '#a4472a',
    800: '#8d3f2b',
    DEFAULT: '#8d3f2b',
    900: '#6b3223',
    950: '#391811',
  },
  'beige': {
    50: '#fbf2df',
    DEFAULT: '#fbf2df',
    100: '#f8eacd',
    200: '#f0d397',
    300: '#e9b860',
    400: '#e3a03c',
    500: '#db8125',
    600: '#c2611d',
    700: '#a1461c',
    800: '#83381d',
    900: '#6c2e1b',
    950: '#3e160a',
  },
  'bone': {
    50: '#ffffff',
    DEFAULT: '#ffffff',
    100: '#efefef',
    150: '#e4e4e5',
    200: '#dcdcdc',
    300: '#bdbdbd',
    400: '#989898',
    500: '#7c7c7c',
    600: '#656565',
    700: '#525252',
    800: '#464646',
    900: '#3d3d3d',
    950: '#292929',
  },
  'bowl': {
    50: '#f7f7f7',
    100: '#ececed',
    200: '#dededf',
    300: '#c7c8c9',
    400: '#a7a8a9',
    DEFAULT: '#a7a8a9',
    500: '#97989a',
    600: '#878889',
    700: '#797a7c',
    800: '#666667',
    900: '#535455',
    950: '#353536',
  },
  'carrot': {
    50: '#fff6ec',
    100: '#ffecd3',
    200: '#ffd5a5',
    300: '#ffb66d',
    400: '#ff8b32',
    500: '#ff6a0a',
    600: '#fe5000',
    DEFAULT: '#fe5000',
    700: '#cc3702',
    800: '#a12c0b',
    900: '#82270c',
    950: '#461004',
  },
  'chew-toy': {
    50: '#fcf3f7',
    100: '#fae9f1',
    200: '#f6d4e2',
    300: '#f1b0ca',
    400: '#e782a9',
    DEFAULT: '#e782a9',
    450: '#f977ad', // not in accounts
    500: '#db5987',
    600: '#c83a66',
    700: '#ad294e',
    800: '#8f2541',
    900: '#782339',
    950: '#480f1e',
  },
  'fish': {
    50: '#eefaff',
    100: '#dcf5ff',
    200: '#b2eeff',
    300: '#6de3ff',
    400: '#20d5ff',
    500: '#00c0ff',
    600: '#009bdf',
    700: '#007bb4',
    800: '#006894',
    900: '#004f71',
    DEFAULT: '#004f71',
    950: '#003651',
  },
  'frisbee': {
    800: '#ffa193',
    900: '#ee2737',
    DEFAULT: '#ee2737',
  },
  'kale': {
    50: '#f6f5ef',
    100: '#ebeadc',
    200: '#d8d7be',
    300: '#bfbe97',
    400: '#a7a674',
    500: '#8b8b57',
    600: '#6e6e42',
    700: '#535435',
    DEFAULT: '#535435',
    800: '#45462e',
    900: '#3c3d2a',
    950: '#1e1f14',
  },
  'mushroom': {
    50: '#fcf7f0',
    100: '#f8ebdc',
    200: '#f1d4b7',
    250: '#ebc49e',
    300: '#e7b78a',
    DEFAULT: '#e7b78a',
    400: '#dc925b',
    500: '#d5763a',
    600: '#c65f30',
    700: '#a54a29',
    800: '#843d28',
    900: '#6b3323',
    950: '#391811',
  },
  'peanut-butter': {
    50: '#ffffea',
    100: '#fffdc5',
    200: '#fffb85',
    300: '#fff246',
    400: '#ffe51b',
    500: '#ffc600',
    DEFAULT: '#ffc600',
    600: '#e29a00',
    700: '#bb6d02',
    800: '#985408',
    900: '#7c450b',
    950: '#482400',
  },
  'plate': {
    50: '#e9fffe',
    100: '#c9fffc',
    200: '#99fffd',
    300: '#54ffff',
    400: '#07f3ff',
    500: '#00d5ef',
    600: '#00a9c9',
    700: '#0086a1',
    800: '#086b82',
    900: '#0c586d',
    950: '#003e51',
    DEFAULT: '#003e51',
  },
  'potato': {
    50: '#faf8ec',
    100: '#f2eecf',
    200: '#e7dda1',
    300: '#d9c56b',
    400: '#ccaf43',
    500: '#bd9a35',
    600: '#a37a2b',
    700: '#825b26',
    800: '#744f28',
    DEFAULT: '#744f28',
    900: '#5e3f25',
    950: '#362112',
  },
  'red-apple': {
    50: '#fdf3f3',
    100: '#fce4e5',
    200: '#faced0',
    300: '#f5acaf',
    400: '#ee7b7f',
    500: '#e25156',
    600: '#ce3439',
    700: '#ad282d',
    800: '#8f2529',
    900: '#7c2629',
    DEFAULT: '#7c2629',
    950: '#400f11',
  },
  'shoe': {
    50: '#f4f4f2',
    100: '#e3e3de',
    200: '#cac8be',
    300: '#aba899',
    400: '#938f7c',
    500: '#84806e',
    600: '#716b5d',
    700: '#5b554d',
    800: '#4F4a44', // different from accounts
    900: '#3d3935',
    DEFAULT: '#3d3935',
    950: '#272421',
  },
  'squash': {
    50: '#fff8eb',
    100: '#ffecc6',
    200: '#ffd688',
    300: '#ffbb4a',
    350: '#ffa52b', // not in mktg design
    400: '#feb430',
    DEFAULT: '#feb430',
    500: '#f97c07',
    600: '#dd5702',
    700: '#b73906',
    800: '#942b0c',
    900: '#7a240d',
    950: '#461002',
  },
};

module.exports = {
  content: ['./src/marketing/**/*.{js,ts,jsx,tsx}'],
  theme: {
    fontFamily: {
      display: ['Druk', 'sans-serif'],
      sans: ['GTAmerica', 'sans-serif'],
    },
    fontSize: {
      'xs': '12px',
      'sm': '14px',
      'base': '16px',
      'lg': '18px',
      'xl': '21px',
      '2xl': '24px',
      '3xl': '28px',
      '4xl': '34px',
      '5xl': '40px',
      '6xl': '48px',
      '7xl': '56px',
      '8xl': '72px',
      'xs-reg-d': [
        '14px',
        {
          lineHeight: '115%',
          fontWeight: 'normal',
        },
      ],
      'xs-med-d': [
        '14px',
        {
          lineHeight: '115%',
          fontWeight: '500',
        },
      ],
      'sm-reg-d': [
        '16px',
        {
          lineHeight: '125%',
          fontWeight: 'normal',
          letterSpacing: '-0.02em',
        },
      ],
      'sm-med-d': [
        '16px',
        {
          lineHeight: '125%',
          fontWeight: '500',
          letterSpacing: '-0.02em',
        },
      ],
      'md-reg-d': [
        '18px',
        {
          lineHeight: '125%',
          fontWeight: 'normal',
          letterSpacing: '-0.02em',
        },
      ],
      'md-med-d': [
        '18px',
        {
          lineHeight: '125%',
          fontWeight: '500',
          letterSpacing: '-0.02em',
        },
      ],
      'lg-reg-d': [
        '20px',
        {
          lineHeight: '125%',
          fontWeight: 'normal',
          letterSpacing: '-0.02em',
        },
      ],
      'lg-med-d': [
        '20px',
        {
          lineHeight: '125%',
          fontWeight: '500',
          letterSpacing: '-0.02em',
        },
      ],
      'xl-reg-d': [
        '26px',
        {
          lineHeight: '125%',
          fontWeight: 'normal',
          letterSpacing: '-0.02em',
        },
      ],
      'xl-med-d': [
        '26px',
        {
          lineHeight: '125%',
          fontWeight: '500',
          letterSpacing: '-0.02em',
        },
      ],
      'xs-reg-m': [
        '12px',
        {
          lineHeight: '115%',
          fontWeight: 'normal',
        },
      ],
      'xs-med-m': [
        '12px',
        {
          lineHeight: '115%',
          fontWeight: '500',
        },
      ],
      'sm-reg-m': [
        '14px',
        {
          lineHeight: '125%',
          fontWeight: 'normal',
          letterSpacing: '-0.02em',
        },
      ],
      'sm-med-m': [
        '14px',
        {
          lineHeight: '125%',
          fontWeight: '500',
          letterSpacing: '-0.02em',
        },
      ],
      'md-reg-m': [
        '16px',
        {
          lineHeight: '125%',
          fontWeight: 'normal',
          letterSpacing: '-0.02em',
        },
      ],
      'md-med-m': [
        '16px',
        {
          lineHeight: '125%',
          fontWeight: '500',
          letterSpacing: '-0.02em',
        },
      ],
      'lg-reg-m': [
        '18px',
        {
          lineHeight: '125%',
          fontWeight: 'normal',
          letterSpacing: '-0.02em',
        },
      ],
      'lg-med-m': [
        '18px',
        {
          lineHeight: '125%',
          fontWeight: '500',
          letterSpacing: '-0.02em',
        },
      ],
      'xl-reg-m': [
        '24px',
        {
          lineHeight: '125%',
          fontWeight: 'normal',
          letterSpacing: '-0.02em',
        },
      ],
      'xl-med-m': [
        '24px',
        {
          lineHeight: '125%',
          fontWeight: '500',
          letterSpacing: '-0.02em',
        },
      ],
      '2xs-head-d': [
        '16px',
        {
          lineHeight: '85%',
          fontWeight: 'bold',
          letterSpacing: '0.02em',
        },
      ],
      'xs-head-d': [
        '26px',
        {
          lineHeight: '90%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      'sm-head-d': [
        '36px',
        {
          lineHeight: '85%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      'md-head-d': [
        '48px',
        {
          lineHeight: '100%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      'md2-head-d': [
        '40px',
        {
          lineHeight: '100%',
          fontWeight: '800',
          letterSpacing: '0.02em',
        },
      ],
      'lg-head-d': [
        '52px',
        {
          lineHeight: '90%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      'xl-head-d': [
        '62px',
        {
          lineHeight: '90%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      '2xl-head-d': [
        '88px',
        {
          lineHeight: '100%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      '3xl-head-d': [
        '100px',
        {
          lineHeight: '95%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      '2xs-head-m': [
        '16px',
        {
          lineHeight: '85%',
          fontWeight: 'bold',
          letterSpacing: '0.02em',
        },
      ],
      'xs-head-m': [
        '26px',
        {
          lineHeight: '90%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      'sm-head-m': [
        '32px',
        {
          lineHeight: '85%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      'md-head-m': [
        '42px',
        {
          lineHeight: '100%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      'md2-head-m': [
        '34px',
        {
          lineHeight: '100%',
          fontWeight: '800',
          letterSpacing: '0.02em',
        },
      ],
      'lg-head-m': [
        '48px',
        {
          lineHeight: '90%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      'xl-head-m': [
        '56px',
        {
          lineHeight: '90%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      '2xl-head-m': [
        '88px',
        {
          lineHeight: '100%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      '3xl-head-m': [
        '88px',
        {
          lineHeight: '95%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      'lg-nav-d': [
        '20px',
        {
          lineHeight: '100%',
          fontWeight: 'bold',
          letterSpacing: '0.02em',
        },
      ],
      'lg-nav-m': [
        '48px',
        {
          lineHeight: '85%',
          fontWeight: 'bold',
          letterSpacing: '0.01em',
        },
      ],
      'overline-nav-d': [
        '14px',
        {
          lineHeight: '100%',
          fontWeight: 'bold',
          letterSpacing: '0.1em',
        },
      ],
    },
    fontWeight: {
      'thin': '100',
      'hairline': '100',
      'extralight': '200',
      'light': '300',
      'normal': '400',
      'regular': '400',
      'medium': '500',
      'semibold': '600',
      'bold': '700',
      'extrabold': '800',
      'extra-bold': '800',
      'heavy': '800',
      'black': '900',
      'super': '900',
    },
    lineHeight: {
      sm: '16px',
      md: '20px',
      lg: '24px',
      xl: '30px',
    },
    minWidth: {
      'xs': '22.5rem',
      'sm': '34.5rem',
      'md': '46.5rem',
      'lg': '58.5rem',
      'xl': '70.5rem',
      '2xl': '90rem',
    },
    maxWidth: {
      'xs': '22.5rem',
      'sm': '34.5rem',
      'md': '46.5rem',
      'lg': '58.5rem',
      'xl': '70.5rem',
      '2xl': '90rem',
    },
    extend: {
      // TODO (geraldiner): Update this to have a more consistent naming convention
      borderRadius: {
        xs: '4px',
        sm: '8px',
        sm2: '12px',
        md: '16px',
        lg: '24px',
        pill: '999px',
      },
      borderWidth: {
        xs: '1px',
        sm: '2px',
      },
      colors: () => ({
        ...colors,
        surface: {
          'page': colors.beige.DEFAULT,
          'white': colors.bone.DEFAULT,
          'cream': colors.mushroom[50],
          'beige': colors.beige[100],
          'mushroom': colors.mushroom[200],
          'mushroom-dark': colors.mushroom.DEFAULT,
          'blue': colors.fish.DEFAULT,
          'blue-dark': colors.plate.DEFAULT,
          'green': colors.potato[200],
          'black': colors.shoe.DEFAULT,
          'grey': colors.bone[100],
          'bacon': colors.bacon.DEFAULT,
          'scrim': 'rgba(39 36 33 0.3)',
        },
        text: {
          'heading': colors.shoe.DEFAULT,
          'body': colors.shoe.DEFAULT,
          'caption': colors.bowl[800],
          'white': colors.bone.DEFAULT,
          'yellow-darkbg': colors.squash.DEFAULT,
        },
        border: {
          'base': '#E6DCC7',
          'grey': colors.bowl[300],
          'green': colors.potato[300],
          'mushroom': colors.mushroom.DEFAULT,
          'mushroom-dark': colors.mushroom[400],
          'beige': colors.beige[200],
          'shoe': colors.shoe.DEFAULT,
        },
        deco: {
          'grey': colors.bone[200],
          'blue': colors.fish.DEFAULT,
          'dark-blue': colors.plate.DEFAULT,
          'light-pink': colors.frisbee[800],
          'pink': colors['chew-toy'][450],
          'orange': colors.carrot.DEFAULT,
          'yellow': colors.squash[400],
          'tan': colors.mushroom.DEFAULT,
          'green': colors.kale.DEFAULT,
          'brown': colors.potato.DEFAULT,
          'dark-red': colors['red-apple'].DEFAULT,
          'dark-purple': '#651C32',
        },
        icon: {
          'white': colors.bone.DEFAULT,
          'light-grey': colors.bone[200],
          'dark-grey': colors.shoe[500],
          'dark': colors.shoe.DEFAULT,
          'bg': colors.carrot[500],
        },
        action: {
          'surface-primary': colors.squash.DEFAULT,
          'surface-secondary': colors.squash[200],
          'surface-tertiary': colors.shoe[950],
          'text-link': colors.squash[700],
          'text-input-label': colors.shoe[950],
        },
        state: {
          'inactive-light': colors.bone[150],
          'inactive': colors.bowl.DEFAULT,
          'disabled-bg': colors.bone[150],
          'active': colors.fish[700],
          'active-bg': colors.fish[100],
          'inactive-md': colors.bone[500],
          'inactive-dark': colors.bone[600],
          'inactive-price-level': '#3d393540',
          'error': '#DC2626',
          'success': '#16A34A',
          'hover-primary-account': colors.squash[500],
          'hover-secondary-account': colors.squash[300],
          'hover-tertiary-account': colors.shoe.DEFAULT,
          'hover-shoe-website': colors.bone[950],
          'hover-squash-website': colors.squash[200],
          'hover-link': colors.squash[900],
        },
      }),
      sizing: {
        50: '1px',
        100: '2px',
        200: '4px',
        300: '8px',
        500: '12px',
        600: '16px',
        700: '20px',
        800: '24px',
        900: '32px',
        1000: '40px',
        1100: '48px',
        1200: '56px',
        1300: '80px',
        1400: '96px',
        1500: '120px',
      },
      spacing: {
        '15': '3.75rem',
        '60': '15rem',
        '3xs-m': '8px',
        '2xs-m': '12px',
        'xs-m': '16px',
        'sm-m': '20px',
        'md-m': '24px',
        'lg-m': '28px',
        'xl-m': '32px',
        '2xl-m': '40px',
        '3xl-m': '48px',
        '4xl-m': '64px',
        '3xs-d': '16px',
        '2xs-d': '20px',
        'xs-d': '24px',
        'sm-d': '28px',
        'md-d': '32px',
        'lg-d': '32px',
        'xl-d': '40px',
        '2xl-d': '48px',
        '3xl-d': '56px',
        '4xl-d': '80px',
        '2xs-button': '4px',
        'xs-button': '8px',
        'sm-button': '12px',
        'md-button': '16px',
        'md-md-button': '20px',
        'lg-button': '24px',
        'xl-button': '32px',
        '2xl-button': '32px',
        'sm-card-m': '24px',
        'md-card-m': '32px',
        'lg-card-m': '40px',
        'xl-card-m': '48px',
        'sm-card-d': '32px',
        'md-card-d': '40px',
        'lg-card-d': '48px',
        'xl-card-d': '56px',
        '3xs-gutter': '8px',
        '2xs-gutter': '16px',
        'xs-gutter': '24px',
        'sm-gutter': '32px',
        'md-gutter': '48px',
        'lg-gutter': '60px',
        'xl-gutter': '80px',
        '2xl-gutter': '108px',
        '3xl-gutter': '212px',
        '4xl-gutter': '328px',
        'sm-page-bottom-m': '40px',
        'sm-page-bottom-d': '80px',
        'xl-page-bottom-m': '72px',
        'xl-page-bottom-d': '96px',
        'md-page-bottom-web': '60px',
        '2xl-page-bottom-web': '108px',
        '3xl-page-bottom-web': '120px',
        'm-page-top-m': '40px',
        'm-page-top-d': '48px',
        'xl-page-top-m': '48px',
        'xl-page-top-d': '64px',
        'max-width-block-xs': '360px',
        'max-width-block-sm': '552px',
        'max-width-block-md': '744px',
        'max-width-block-lg': '936px',
        'max-width-block-xl': '1128px',
        'max-width-block-2xl': '1440px',
        'min-width-block': '280px',
      },
    },
  },
  plugins: [tailwindCssForms],
};

module.exports.colors = colors;
